import { ColumnSchemaSummarizationType, NodeType } from 'shared-types';

export const DEFAULT_SPREADSHEET_HEIGHT_LOADING = 375;
export const DEFAULT_ROW_HEIGHT = 25;
export const COLUMN_DATA_SOURCES = [
  NodeType.FORMULA,
  NodeType.WINDOW_FUNCTION,
  NodeType.PROCV,
  NodeType.SUM_IF,
];

export const COLUMN_SCHEMA_SUMMARIZATION_TRANSLATION: Record<
  ColumnSchemaSummarizationType,
  string
> = {
  [ColumnSchemaSummarizationType.AVG]: 'Média',
  [ColumnSchemaSummarizationType.COUNT]: 'Contagem',
  [ColumnSchemaSummarizationType.MAX]: 'Máximo',
  [ColumnSchemaSummarizationType.MIN]: 'Mínimo',
  [ColumnSchemaSummarizationType.SUM]: 'Soma',
  [ColumnSchemaSummarizationType.COUNT_DISTINCT]: 'Contagem Distinta',
};

export const ISODATE_MODEL = new Date('2020-05-04T15:41:45.000Z');
